"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerAnimationComponent = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
const types_1 = require("../../../Shared/types");
class PlayerAnimationComponent extends gotti_1.Component {
    constructor(skeletonName) {
        super(Constants_1.SYSTEMS.PLAYER_ANIMATION);
        // @ts-ignore
        this.skeletonName = skeletonName || 'default';
    }
    initSkeleton(gottimation, direction) {
        return __awaiter(this, void 0, void 0, function* () {
            direction = direction || 'south';
            this.skeleton = yield gottimation.createSkeleton(this.skeletonName, { direction });
            yield this.skeleton.setSkins([
                { atlasName: 'player', skinName: 'default.png' }
            ]);
            this.emit('skeleton-ready', this.skeleton);
            return this.skeleton;
        });
    }
    canPlayActionAnimation() {
        if (!this.skeleton)
            return false;
        return this.skeleton.baseTrack.stopped || !this.skeleton.baseTrack.currentAction || (this.skeleton.baseTrack.currentAction.includes('walk') || this.skeleton.baseTrack.currentAction.includes('idle'));
    }
    updateAnimation(delta, actionComponent) {
        if (this.playerMovementComponent.disabled)
            return;
        if (['swing_net', 'dig'].includes(this.skeleton.baseTrack.currentAction)) {
            this.skeleton.direction = actionComponent.actionDirection || this.skeleton.direction;
        }
        else {
            if (this.playerMovementComponent.movingDirection !== null) {
                // player is moving, so set the direction and play the walk ani if not already.
                this.skeleton.direction = this.playerMovementComponent.movingDirection;
                // @ts-ignore
                if (this.skeleton.baseTrack.currentAction !== 'walk' || this.skeleton.baseTrack.stopped) {
                    this.skeleton.play('walk', null, { loop: true });
                }
            }
            else {
                if ((this.skeleton.baseTrack.currentAction && this.skeleton.baseTrack.currentAction.includes('walk')) || !this.skeleton.baseTrack.stopped) {
                    this.skeleton.stop();
                }
            }
        }
        this.skeleton.update(delta);
    }
    isReady() {
        return !!this.skeleton;
    }
    onAdded(entity) {
        this.entity = entity;
        this.playerMovementComponent = entity.getComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT);
        if (entity.type == types_1.EntityTypes.ClientPlayer && !this.playerMovementComponent)
            throw new Error(`Expected a player movement componnet.`);
    }
}
exports.PlayerAnimationComponent = PlayerAnimationComponent;
//# sourceMappingURL=module.js.map